import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TEXT = "We don't just drop off machines. We partner with local businesses to plan, install and service entertainment that keeps customers coming back — and keeps revenue coming in.";
const HIGHLIGHT = new Set(["partner", "install", "service", "coming", "back", "revenue"]);

const Word = ({ w, range, progress }) => {
  const opacity = useTransform(progress, range, [0.12, 1]);
  const y = useTransform(progress, range, [8, 0]);
  const key = w.toLowerCase().replace(/[^a-z]/g, "");
  return (
    <motion.span style={{ opacity, y }} className={`mr-[0.25em] inline-block ${HIGHLIGHT.has(key) ? "text-volt" : ""}`}>
      {w}
    </motion.span>
  );
};

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.6"] });
  const words = TEXT.split(" ");
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);
  return (
    <section ref={ref} className="relative py-32 lg:py-48" data-testid="manifesto-section">
      <div className="container-x grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-3">
          <p className="eyebrow">Our Promise</p>
          <div className="mt-6 h-px w-full max-w-[200px] bg-white/10">
            <motion.div style={{ scaleX: lineScale }} className="h-px origin-left bg-volt" />
          </div>
        </div>
        <p className="font-display text-3xl font-semibold leading-[1.15] tracking-tight text-white sm:text-5xl lg:col-span-9 lg:text-6xl">
          {words.map((w, i) => (
            <Word key={i} w={w} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]} />
          ))}
        </p>
      </div>
    </section>
  );
};
